/* ============================================================
   LOCKSTEED — Driveway Defender (slug 'locksteed').
   Cargado por layout/landing.liquid (case 'locksteed').
   Bloques: countdown · galería (thumbs) · selección de bundle (.ls-bundle) ·
   sticky bar · disparo del modal Releasit COD (todos los .ls-cta).
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N para que el pedido lleve las unidades reales
   (Dropi) y el total quede en el precio del bundle. NO usar _rsiV2.setState como
   primer path. Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- countdown ---------- */
(function () {
  var t = 7 * 3600 + 44 * 60 + 34;
  function tick() {
    t = t > 0 ? t - 1 : 0;
    var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    var H = document.getElementById('c-h'), M = document.getElementById('c-m'), S = document.getElementById('c-s');
    if (H) H.innerHTML = String(h).padStart(2, '0') + '<small>H</small>';
    if (M) M.innerHTML = String(m).padStart(2, '0') + '<small>M</small>';
    if (S) S.innerHTML = String(s).padStart(2, '0') + '<small>S</small>';
  }
  setInterval(tick, 1000);
})();

/* ---------- galería thumbs ---------- */
document.querySelectorAll('.ls-thumb').forEach(function (t) {
  t.addEventListener('click', function () {
    document.querySelectorAll('.ls-thumb').forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
    var main = document.getElementById('mainImg');
    if (main && t.dataset.src) main.src = t.dataset.src;
  });
});

/* ---------- sticky bar ---------- */
window.addEventListener('scroll', function () {
  var y = window.scrollY, sticky = document.getElementById('sticky');
  if (sticky) sticky.classList.toggle('show', y > 800 && y < document.body.scrollHeight - 1400);
});

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var LOCKSTEED_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function locksteedFindReleasitButton() {
  for (var i = 0; i < LOCKSTEED_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(LOCKSTEED_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var locksteedSelectedVariantId = null;
var locksteedSelectedQty = 1;

function locksteedSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

/* ---------- selección de bundle ---------- */
var lsBundles = document.querySelectorAll('.ls-bundle');
function lsPick(b) {
  lsBundles.forEach(function (x) { x.classList.remove('sel'); });
  b.classList.add('sel');
  var id = b.getAttribute('data-bundle-variant-id');
  if (id) {
    locksteedSelectedVariantId = id;
    locksteedSelectedQty = parseInt(b.getAttribute('data-bundle-qty'), 10) || 1;
    locksteedSetVariantOnAllForms(locksteedSelectedVariantId, locksteedSelectedQty);
  }
}
lsBundles.forEach(function (b) { b.addEventListener('click', function () { lsPick(b); }); });
window.lsPick = lsPick;

function locksteedTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || locksteedSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || locksteedSelectedQty;
  if (variantId) locksteedSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = locksteedFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = locksteedFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.locksteedTriggerCOD = locksteedTriggerCOD;
window.openCheckout = function () { locksteedTriggerCOD(null); };

/* ---------- todos los CTA disparan COD ---------- */
document.querySelectorAll('.ls-cta').forEach(function (btn) {
  btn.addEventListener('click', function () { locksteedTriggerCOD(null); });
});

/* ---------- init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.ls-bundle.sel') || document.querySelector('.ls-bundle');
  if (active) lsPick(active);
})();
